import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";


class EmailReportStore {
  emailStore = [];
  reportNames = [];
  reportsList = [];
  groupList = [];
  subGroupList = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      emailStore: observable,
      loading: observable,
      reportNames: observable,
      reportsList: observable,
      total: observable,
      groupList: observable,
      subGroupList: observable,
      loadData: action,
      addData: action,
      getVehicles: action,
      deleteRecord: action,
      getEmailReportData: action,
      getReportsName: action,
      getVehicleGroup: action,
      getVehicleSubGroup: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, searchField, companyId, isadmin, userId }) {
    this.loading = true;

    var postData = { companyId: companyId, offset: offset, limit: limit, isadmin: isadmin, userId: userId };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .get(config.NodeUrl + "/EmailReport/getErList", { params: postData });
      this.emailStore = response?.data?.data
    }
    else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=emailreport&a=getErList", "postData=" + base64Input);

      this.emailStore = response?.data?.data?.erList;
      this.total = parseInt(response.data.data.TotalCount);
    }

    this.loading = false;
  }
  async addData(emailReportData) {
    var postData = emailReportData;
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/EmailReport/addUpdateEmailData", postData);
    }
    else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=emailreport&a=update", "postData=" + base64Input);
    }
    return response.data;
  }

  async getVehicles({ companyId }) {
    var postData = { companyId: companyId, isemailreport: 1 };
    if (config.pythonReport == 1) {
      const response = await postApi
        .getClient()
        .get(config.NodeUrl + "/vehicle/getVehicles", { params: postData });
      this.vehicles = response?.data?.vehicleData;
      return response.data.vehicleData;
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
      this.vehicles = response.data.data;
      return response.data.data;
    }
  }

  async deleteRecord({ er_Id }) {
    const postData = { er_Id: er_Id };
    if (config.pythonReport == 1) {
      const response = await postApi
        .getClient()
        .delete(config.NodeUrl + "/EmailReport/deleteEmailData", { params: postData });
      return response;
    }
    else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=emailreport&a=delete", "postData=" + base64Input);

      return response;
    }

  }

  async getEmailReportData(Id, companyId) {
    var postData = { Id: Id, companyId: companyId, limit: 1, offset: 0 };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .get(config.NodeUrl + "/EmailReport/getErList", { params: postData });
      return response?.data?.data[0];

    }
    else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=emailreport&a=getErList", "postData=" + base64Input);

      // return response?.data?.data?.drivers[0];
      return response?.data?.data?.erList[0];
    }

  }

  async getReportsName(filterBy) {
    var postData = {};
    const params = { filterBy };
    if (config.pythonReport == 1) {
      const response = await postApi
        .getClient()
        .get(config.NodeUrl + "/EmailReport/getReportsList", { params });
      this.reportsList = response?.data?.data
      return response.data.data;
    }
    else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=report&a=getReport", "postData=" + base64Input);

      this.reportsList = response.data.data.reports;
      return response.data.data.reports;
    }

  }

  async getVehicleGroup({ companyId, userId, isadmin }) {
    console.log("getdata");
    var postData = { companyId: companyId, userId: userId, isadmin: isadmin };

    if (config.pythonReport == 1) {
      const response = await postApi
        .getClient()
        .get(config.NodeUrl + "/deviceGroup/getDeviceGroup", { params: postData });
      this.groupList = response?.data?.DeviceGroupData[0]?.devicegroups;
      return response.data.DeviceGroupData;
    }
    else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=devicegroup&a=getVehicleGropups",
          "postData=" + base64Input
        );

      this.groupList = response.data.data;
    }

  }

  async getVehicleSubGroup({
    deviceGroupId,
    deviceSubGroupId,
    companyId,
    userId,
    isadmin,
    subgroup,
  }) {

    if (config.pythonReport == 1) {
      var postData = {
        deviceGroupId: [deviceGroupId],
        deviceSubGroupId: deviceSubGroupId,
        companyId: companyId,
        userId: userId,
        isadmin: isadmin,
      };
      const response = await postApi
        .getClient()
        .get(config.NodeUrl + "/deviceGroup/getReportSubGroupAndVehicle", { params: postData });
      if (subgroup) {
        // this.subGroupList = response.data.data?.subgroup;
        this.subGroupList = response.data.data[0]?.subgroup;
        this.vehicles = response.data.data[0]?.vehicles;
      } else {
        // this.vehicles = response.data.data?.vehicles;
        this.vehicles = response.data.data[0]?.vehicles;
      }

      return response.data.data[0]?.subgroup;
    }
    else {
      var postData = {
        deviceGroupId: deviceGroupId,
        deviceSubGroupId: deviceSubGroupId,
        companyId: companyId,
        userId: userId,
        isadmin: isadmin,
      };
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=devicegroup&a=getGroups", "postData=" + base64Input);
      if (subgroup) {
        this.subGroupList = response.data.data?.subgroup;
      } else {
        this.vehicles = response.data.data?.vehicles;
      }

      return response.data.data?.subgroup
    }

  }

  async getRuleTriggerName() {

    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/EmailReport/getRuleTriggerList");
    // config.NodeUrl
    this.ruleTriggerList = response?.data?.data;
    return response?.data?.data;
  }
}

export default EmailReportStore;
